import React, { useState, useEffect } from "react";
import makeSelectOptionsFromKeyValuePairs from "../../utils/makeSelectOptionsFromKeyValuePairs";
import { resourceUrls } from "../../config";
import _isEmpty from "lodash/isEmpty";
import { get } from "../api";
import SchoolLeavingQualifications from "./components/SchoolLeavingQualifications";
import Subjects from "./components/Subjects";
import _get from "lodash/get";

const fetchQualificationTypeOptions = async setQualificationTypeOptions => {
    const response = await get({
        url: resourceUrls.qualifications.getSchoolLeavingQualifications,
    });

    const qualificationTypes = _get(response, "success.data")
        ? response.success.data
        : [];
    const qualificationTypeOptions = makeSelectOptionsFromKeyValuePairs(
        qualificationTypes
    );

    return setQualificationTypeOptions(qualificationTypeOptions);
};

const Qualifications = () => {
    const [qualificationType, setQualificationType] = useState("");
    const [qualificationTypeOptions, setQualificationTypeOptions] = useState(
        null
    );

    useEffect(() => {
        fetchQualificationTypeOptions(setQualificationTypeOptions);
    }, []);

    return _isEmpty(qualificationType) ? (
        <SchoolLeavingQualifications
            qualificationType={qualificationType}
            setQualificationType={setQualificationType}
            qualificationTypeOptions={qualificationTypeOptions}
        />
    ) : (
        <Subjects
            qualificationType={qualificationType}
            qualificationTypeOptions={qualificationTypeOptions}
        />
    );
};

export default Qualifications;
